import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationItemPriceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemPriceConfig/ItemPriceConfig")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationItemPrice"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationItemPrice"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationItemPriceActivity)
